export default __webpack_public_path__ + "static/media/analytics.d03f9bf2.svg";